export const ENV_NAME: string = process.env.ENV_NAME?.toUpperCase() || "DEVNET";
export const RPC_READ_ENDPOINT = process.env.RPC_READ_ENDPOINT || "https://api.devnet.solana.com";
export const RPC_WRITE_ENDPOINTS = process.env.RPC_WRITE_ENDPOINTS || "https://api.devnet.solana.com";
export const DIVVY_API_URL = process.env.DIVVY_API_URL || "https://api.divvy.haus";